export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11567.d5570175.jpg";